<template>
  <div class="bookMeetings">
    <div v-if="!showServicePeopel">
      <NavBar v-if="sourceIsH5" :narBarTitle="$t('待办')" />
      <van-tabs v-model="active" color="#009BFF" @click="onTabClick" title-active-color="#3972FF" line-height="0px"
        :ellipsis="false">
        <van-tab>
          <div slot="title" class="tabStyle">
            {{ $t('待处理') }}
            <div class="tabNumText" v-if="allNumber > 0">{{ allNumber }}</div>
          </div>
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh"
            :style="{ height: height - 20 + 'px', overflow: 'auto' }">
            <van-list v-model="myLoading" :finished="inviteFinished" @load="onLoad" :immediate-check="false">
              <div class="loading-style" v-if="isLoading">
                <!-- <van-loading type="spinner" vertical>{{
                  $t('加载中...')
                }}</van-loading> -->
              </div>
              <div class="content" v-else>
                <ul v-if="pendingList.length > 0">
                  <li :class="index + 1 == pendingList.length ? 'cardNoMargin' : 'card'
                    " v-for="(item, index) in pendingList" :key="item.id">
                    <div @click="representativeInfo(item)" class="cardStyle">
                      <div class="representativeListName">
                        {{ item.submitterName
                        }}{{ $t(' 提交的 会议室预约申请') }}
                      </div>
                      <div class="representativeOther">
                        <img src="@/assets/images/meetingName.svg" alt="" class="overepresentativeImg" />
                        <div class="representativeOtherName">
                          {{ item.title }}
                        </div>
                      </div>
                      <div class="representativeTime">
                        <img src="@/assets/images/overdueTime.svg" alt="" class="overepresentativeImg" />
                        <div class="representativeOtherTime">
                          {{ item.time }}
                        </div>
                      </div>
                      <div class="representativeOther">
                        <img src="@/assets/images/overdueAddress.svg" alt="" class="overepresentativeImg" />
                        <div class="representativeOtherName">
                          {{ item.meetingRoomName }}
                        </div>
                      </div>
                      <div class="representativeOther">
                        <img src="@/assets/images/level.svg" alt="" class="overepresentativeImg" />
                        <div class="representativeOtherName">
                          {{
                            item.meetingLevel == 1
                              ? $t('1星')
                              : item.meetingLevel == 2
                                ? $t('2星')
                                : item.meetingLevel == 3
                                  ? $t('3星')
                                  : $t('无')
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="operation">
                      <div @click="onRefuse(item)" class="refuseButton" v-if="item.isMydone == 1">
                        {{ $t('拒绝') }}
                      </div>
                      <div @click="onOk(item)" class="okButton" v-if="item.isMydone == 1">
                        {{ $t('同意') }}
                      </div>
                      <div @click="onAllocation(item)" class="allocationBotton" v-if="item.isMydone == 2">
                        {{ $t('分配人员') }}
                      </div>
                      <div @click="onDone(item)" class="allocationBotton" v-if="item.isMydone == 3">
                        {{ $t('完成') }}
                      </div>
                      <div @click="onComment(item)" class="allocationBotton" v-if="item.isMydone == 4">
                        {{ $t('点评') }}
                      </div>
                    </div>
                  </li>
                </ul>
                <div class="no-uesdMeetingRoom" v-else>
                  <img src="@/assets/images/empty.png" alt="" />
                  <div>{{ $t('暂无信息') }}</div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab :title="$t('已处理')">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh"
            :style="{ height: height - 20 + 'px', overflow: 'auto' }">
            <van-list v-model="processedLoading" :finished="inviteFinished" @load="onLoad" :immediate-check="false">
              <div class="loading-style" v-if="isLoading">
                <!-- <van-loading type="spinner" vertical>{{
                  $t('加载中...')
                }}</van-loading> -->
              </div>
              <div class="content" v-else>
                <ul v-if="processedList.length > 0">
                  <li :class="index + 1 == processedList.length
                    ? 'cardNoMargin'
                    : 'card'
                    " v-for="(item, index) in processedList" :key="item.id">
                    <div @click="representativeInfo(item)" class="cardStyle">
                      <div class="representativeListName">
                        {{ item.submitterName
                        }}{{ $t(' 提交的 会议室预约申请') }}
                      </div>
                      <div class="representativeOther">
                        <img src="@/assets/images/meetingName.svg" alt="" class="overepresentativeImg" />
                        <div class="representativeOtherName">
                          {{ item.title }}
                        </div>
                      </div>
                      <div class="representativeTime">
                        <img src="@/assets/images/overdueTime.svg" alt="" class="overepresentativeImg" />
                        <div class="representativeOtherTime">
                          {{ item.time }}
                        </div>
                      </div>
                      <div class="representativeOther">
                        <img src="@/assets/images/overdueAddress.svg" alt="" class="overepresentativeImg" />
                        <div class="representativeOtherName">
                          {{ item.meetingRoomName }}
                        </div>
                      </div>
                      <div class="representativeOther">
                        <img src="@/assets/images/level.svg" alt="" class="overepresentativeImg" />
                        <div class="representativeOtherName">
                          {{
                            item.meetingLevel == 1
                              ? $t('1星')
                              : item.meetingLevel == 2
                                ? $t('2星')
                                : item.meetingLevel == 3
                                  ? $t('3星')
                                  : $t('无')
                          }}
                        </div>
                      </div>
                    </div>
                    <img :src="item.imgUrl" alt="" class="statusImg" />
                  </li>
                </ul>
                <div class="no-uesdMeetingRoom" v-else>
                  <img src="@/assets/images/empty.png" alt="" />
                  <div>{{ $t('暂无信息') }}</div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab :title="$t('我创建')">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh"
            :style="{ height: height - 20 + 'px', overflow: 'auto' }">
            <van-list v-model="createdLoading" :finished="inviteFinished" @load="onLoad" :immediate-check="false">
              <div class="loading-style" v-if="isLoading">
                <!-- <van-loading type="spinner" vertical>{{
                  $t('加载中...')
                }}</van-loading> -->
              </div>
              <div class="content" v-else>
                <ul v-if="createdList.length > 0">
                  <li :class="index + 1 == createdList.length ? 'cardNoMargin' : 'card'
                    " v-for="(item, index) in createdList" :key="item.id">
                    <div @click="representativeInfo(item)" class="cardStyle">
                      <div class="representativeListName">
                        {{ item.submitterName
                        }}{{ $t(' 提交的 会议室预约申请') }}
                      </div>
                      <div class="representativeOther">
                        <img src="@/assets/images/meetingName.svg" alt="" class="overepresentativeImg" />
                        <div class="representativeOtherName">
                          {{ item.title }}
                        </div>
                      </div>
                      <div class="representativeTime">
                        <img src="@/assets/images/overdueTime.svg" alt="" class="overepresentativeImg" />
                        <div class="representativeOtherTime">
                          {{ item.time }}
                        </div>
                      </div>
                      <div class="representativeOther">
                        <img src="@/assets/images/overdueAddress.svg" alt="" class="overepresentativeImg" />
                        <div class="representativeOtherName">
                          {{ item.meetingRoomName }}
                        </div>
                      </div>
                      <div class="representativeOther">
                        <img src="@/assets/images/level.svg" alt="" class="overepresentativeImg" />
                        <div class="representativeOtherName">
                          {{
                            item.meetingLevel == 1
                              ? $t('1星')
                              : item.meetingLevel == 2
                                ? $t('2星')
                                : item.meetingLevel == 3
                                  ? $t('3星')
                                  : $t('无')
                          }}
                        </div>
                      </div>
                    </div>
                    <img :src="item.imgUrl" alt="" class="statusImg" />
                  </li>
                </ul>
                <div class="no-uesdMeetingRoom" v-else>
                  <img src="@/assets/images/empty.png" alt="" />
                  <div>{{ $t('暂无信息') }}</div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab :title="$t('已过期')">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh"
            :style="{ height: height - 20 + 'px', overflow: 'auto' }">
            <van-list v-model="expireLoading" :finished="inviteFinished" @load="onLoad" :immediate-check="false">
              <div class="loading-style" v-if="isLoading">
                <!-- <van-loading type="spinner" vertical>{{
                  $t('加载中...')
                }}</van-loading> -->
              </div>
              <div class="content" v-else>
                <ul v-if="expireList.length > 0">
                  <li :class="index + 1 == expireList.length ? 'cardNoMargin' : 'card'
                    " v-for="(item, index) in expireList" :key="item.id">
                    <div @click="representativeInfo(item)" class="cardStyle">
                      <div class="representativeListName">
                        {{ item.submitterName
                        }}{{ $t(' 提交的 会议室预约申请') }}
                      </div>
                      <div class="representativeOther">
                        <img src="@/assets/images/meetingName.svg" alt="" class="overepresentativeImg" />
                        <div class="representativeOtherName">
                          {{ item.title }}
                        </div>
                      </div>
                      <div class="representativeTime">
                        <img src="@/assets/images/overdueTime.svg" alt="" class="overepresentativeImg" />
                        <div class="representativeOtherTime">
                          {{ item.time }}
                        </div>
                      </div>
                      <div class="representativeOther">
                        <img src="@/assets/images/overdueAddress.svg" alt="" class="overepresentativeImg" />
                        <div class="representativeOtherName">
                          {{ item.meetingRoomName }}
                        </div>
                      </div>
                      <div class="representativeOther">
                        <img src="@/assets/images/level.svg" alt="" class="overepresentativeImg" />
                        <div class="representativeOtherName">
                          {{
                            item.meetingLevel == 1
                              ? $t('1星')
                              : item.meetingLevel == 2
                                ? $t('2星')
                                : item.meetingLevel == 3
                                  ? $t('3星')
                                  : $t('无')
                          }}
                        </div>
                      </div>
                    </div>
                    <img src="@/assets/images/Expired.png" alt="" class="statusImg" />
                  </li>
                </ul>
                <div class="no-uesdMeetingRoom" v-else>
                  <img src="@/assets/images/empty.png" alt="" />
                  <div>{{ $t('暂无信息') }}</div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
    <!-- <TabBar v-if="sourceIsH5 && !showServicePeopel" /> -->
    <van-popup v-model="showOk" position="bottom" safe-area-inset-bottom>
      <div class="popupStyle">
        <div class="popupHeader">
          <div class="popupClose" @click="clickOkClose()">X</div>
          <div class="popupTitle">{{ $t('同意审批') }}</div>
        </div>
        <div class="popupBlock" @click="showArea = true">
          <div class="popupOk">
            <div class="commentStyle">{{ $t('预选会议室：') }}</div>
            <div class="okTextStyle">{{ meetingRoomName }}</div>
          </div>
          <img src="@/assets/images/dropdown.png" alt="" class="dropdownImg" />
        </div>
        <div class="popupOkOther">
          <div class="commentStyle" style="margin-bottom: 10px">
            {{ $t('会议等级：') }}
          </div>
          <van-radio-group v-model="meetingChoseLevel" direction="horizontal">
            <van-radio :name="0">{{ $t('无') }}</van-radio>
            <van-radio :name="1">{{ $t('1星') }}</van-radio>
            <van-radio :name="2">{{ $t('2星') }}</van-radio>
            <van-radio :name="3">{{ $t('3星') }}</van-radio>
          </van-radio-group>
        </div>
        <div class="bookBoxOk">
          <van-button round block native-type="submit" :class="meetingRoomName &&
            (meetingChoseLevel == 0 ||
              meetingChoseLevel == 1 ||
              meetingChoseLevel == 2 ||
              meetingChoseLevel == 3)
            ? 'blue-btn'
            : 'grey-btn'
            " @click="doOk()" :disabled="isUseDoOk">{{ $t('完成') }}</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showRefuse" position="bottom" safe-area-inset-bottom>
      <div class="popupStyle">
        <div class="popupHeader">
          <div class="popupClose" @click="clickRefuseClose()">X</div>
          <div class="popupTitle">{{ $t('拒绝审批') }}</div>
        </div>
        <van-field v-model="refuseMessage" rows="7" autosize type="textarea" :placeholder="$t('请输入拒绝原因')" size="14px" />
        <div class="bookBox">
          <van-button round block type="danger" native-type="submit" class="danger-btn" @click="doRefuse()"
            :disabled="isUseRefuse">{{ $t('拒绝')
            }}</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showAllocation" position="bottom" safe-area-inset-bottom>
      <div class="popupStyle">
        <div class="popupHeader">
          <div class="popupClose" @click="clickAllocationClose()">X</div>
          <div class="popupTitle">{{ $t('分配会务服务人') }}</div>
        </div>
        <div>
          <div class="popupBlock" @click="cilkcshowServicePeopel()">
            <div class="popupOk">
              <div class="commentStyle">{{ $t('服务人：') }}</div>
              <div :class="servicePeopelName ? 'okTextStyle' : 'okTextGreyStyle'">
                {{ servicePeopelName ? servicePeopelName : $t('请选择') }}
              </div>
            </div>
            <img src="@/assets/images/dropdown.png" alt="" class="dropdownImg" />
          </div>
        </div>
        <div class="bookBoxAllocation">
          <van-button round block native-type="submit" :class="servicePeopelName ? 'blue-btn' : 'grey-btn'"
            @click="doAllocation()" :disabled="isUseAllocation">{{ $t('分配') }}</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showDone" position="bottom" safe-area-inset-bottom>
      <div class="popupStyle">
        <div class="popupHeader">
          <div class="popupClose" @click="clickDoneClose()">X</div>
          <div class="popupTitle">{{ $t('会务服务') }}</div>
        </div>
        <div class="popupText">{{ $t('会务服务工作是否完成？') }}</div>
        <div class="bookBox">
          <van-button round block native-type="submit" class="blue-btn" @click="doDone()" :disabled="isUseDone">{{
            $t('完成') }}</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showComment" position="bottom" safe-area-inset-bottom>
      <div class="popupStyle">
        <div class="popupHeader">
          <div class="popupClose" @click="clickCommentClose()">X</div>
          <div class="popupTitle">{{ $t('会务点评') }}</div>
        </div>
        <div class="popupComment">
          <div class="commentStyle">{{ $t('会务点评：') }}</div>
          <van-rate v-model="commentValue" :count="5" color="#FAAD14" />
        </div>
        <div class="bookBox">
          <van-button round block native-type="submit" :class="commentValue >= 1 ? 'blue-btn' : 'grey-btn'"
            @click="doComment()" :disabled="isUseComment">{{ $t('完成') }}</van-button>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showArea" position="bottom" safe-area-inset-bottom>
      <div>
        <div class="timeListTitle">{{ $t('选择会议室') }}</div>
        <van-checkbox-group v-model="areaResult" class="timeList" max="1">
          <div style="position: absolute; top: 0; height: 318px">
            <van-checkbox :name="index" class="timeListCard" icon-size="21px" v-for="(item, index) in areaList"
              :key="index">
              <div class="timeListRange">{{ item.name }}</div>
            </van-checkbox>
          </div>
        </van-checkbox-group>
      </div>
      <div class="bookBox">
        <van-button round block type="info" native-type="submit" class="blue-btn" @click="toMeetingInform">{{ $t('确定')
          }}</van-button>
      </div>
    </van-popup>
    <van-dialog v-model="showToast" show-cancel-button confirmButtonColor="#009BFF" cancelButtonColor="#009BFF"
      @confirm="IsDoOk()" class="outsiderStyle" :cancelButtonText="$t('取消')" :confirmButtonText="$t('确认')">
      <template #title>
        <div class="outsider-title">
          {{ '该会议室没有会务服务，是否要更换' }}
        </div>
      </template>
    </van-dialog>
    <Address :userList="userList" v-if="showServicePeopel" @back="toInform" @confirm="confirmSearch"
      :selectedList="[]" />
    <!-- <van-popup v-model="isCancel" position="bottom"
      :style="{ height: '100%', backgroundColor: 'rgba(255, 255, 255, 0)' }">
      <div class="isCancelMask">
        <van-loading type="spinner" vertical>{{ $t('加载中...') }}</van-loading>
      </div>
    </van-popup> -->
  </div>
</template>
<script>
import NavBar from '@/components/navBar'
import {
  getMeetingRoomByArea,
  getUserList,
  h5MeetingServiceRecord,
  processingData,
  assignPersonnel,
  serviceComplete,
  submitterGrade,
  getMeetingRoomById,
} from '@/services/api'
import Vue from 'vue'
import dayjs from 'dayjs'
import Address from './address.vue'
import TabBar from '@/components/tabBar'
import {
  Calendar,
  Dialog,
  Toast,
  ActionSheet,
  Tab,
  Tabs,
  Search,
  Popup,
  PullRefresh,
  List,
  Loading,
  Field,
  Rate,
  Checkbox,
  CheckboxGroup,
  RadioGroup,
  Radio,
} from 'vant'
Vue.use(Calendar)
Vue.use(Toast)
Vue.use(ActionSheet)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Search)
Vue.use(Popup)
Vue.use(PullRefresh)
Vue.use(List)
Vue.use(Dialog)
Vue.use(Loading)
Vue.use(Field)
Vue.use(Rate)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(RadioGroup)
Vue.use(Radio)

export default {
  name: 'BookMeetings',
  components: {
    NavBar,
    Address,
    TabBar,
  },
  data() {
    return {
      active: 0,
      newActive: 0,
      sourceIsH5: true,
      height: '',
      originDate: '',
      isCancel: false,
      isLoading: false,
      myLoading: false,
      showArea: false,
      areaList: [],
      areaid: '',
      meetingRoomName: '',
      areaResult: [],
      pendingList: [],
      processedList: [],
      createdList: [],
      expireList: [],
      pendingPage: 0,
      processedPage: 0,
      createdPage: 0,
      expirePage: 0,
      inviteFinished: false,
      myFinished: false,
      processedLoading: false,
      createdLoading: false,
      expireLoading: false,
      choseData: {},
      showRefuse: false,
      isUseRefuse: false,
      showOk: false,
      isUseDoOk: false,
      showAllocation: false,
      isUseAllocation: false,
      showComment: false,
      isUseComment: false,
      showDone: false,
      isUseDone: false,
      ifAgree: false,
      refuseMessage: '',
      allNumber: '',
      pendingPage: 0,
      processedPage: 0,
      createdPage: 0,
      expirePage: 0,
      commentValue: 0,
      meetingChoseLevel: 0,
      servicePeopelName: '',
      servicePeopelId: '',
      servicePersonnerlDpt: '',
      showServicePeopel: false,
      userList: [],
      showToast: false,
      locale: localStorage.getItem('locale') || navigator.language || 'zh-CN'
    }
  },
  methods: {
    async getUsers(companyId) {
      try {
        const res = await getUserList({ companyId })
        let arr = [...res]
        this.userList = arr
      } catch (error) {
        console.log(error)
      }
    },
    onTabClick(active) {
      if (active == this.newActive) {
        return
      } else {
        this.active = active
        this.newActive = active
        this.myFinished = false
        this.inviteFinished = false
        this.pendingPage = 0
        this.processedPage = 0
        this.createdPage = 0
        this.expirePage = 0
        this.onLoad()
      }
    },
    async getAreaId(developerId) {
      try {
        const res = await getMeetingRoomByArea({
          developerId,
        })
        let tmpArr = [...res]
        tmpArr.forEach((item, idx) => {
          if (item.state === 'nouse') {
            // tmpArr.splice(idx, 1)
          }
        })
        tmpArr.forEach((item) => {
          if (item.state != 'nouse') {
            this.areaList.push({ name: item.name, id: item.id })
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    getWeekName(week) {
      switch (week) {
        case '1':
          return this.$t('周一')
          break
        case '2':
          return this.$t('周二')
          break
        case '3':
          return this.$t('周三')
          break
        case '4':
          return this.$t('周四')
          break
        case '5':
          return this.$t('周五')
          break
        case '6':
          return this.$t('周六')
          break
        case '7':
          return this.$t('周日')
          break
      }
    },
    async fetchAppointmentList(data) {
      this.isCancel = data.isCancel
      // this.isLoading = true
      if (data.loading) {
        switch (data.tabState) {
          case 'PENDING':
            this.myLoading = true //待处理
            break
          case 'PROCESSED':
            this.processedLoading = true //已处理
            break
          case 'CREATE':
            this.createdLoading = true //我创建
            break
          case 'EXPIRED':
            this.expireLoading = true //已过期
            break
        }
      }
      let params = {}
      params['tabState'] = data.tabState
      params['companyId'] = parseInt(data.companyId)
      params['staffId'] = data.staffId
      params['page'] = data.page
      params['pageSize'] = data.pageSize
      try {
        let newRes = await h5MeetingServiceRecord(params)
        newRes?.results?.forEach((item) => {
          let time = ''
          if (
            item.meetingType &&
            item.meetingType == 'WEEKLY' &&
            item.type != 'MEETING_SERVICE'
          ) {
            let day1 = dayjs(item.meetingStartTime.split(' ')[0]).format(
              'YYYY.MM.DD'
            )
            let day2 = dayjs(item.weeklyEndTime).format('YYYY.MM.DD')
            let start = item.meetingStartTime.split(' ')[1]
            let end = item.meetingEndTime.split(' ')[1]
            let startTime = start?.split(':')[0] + ':' + start?.split(':')[1]
            let endTime = end?.split(':')[0] + ':' + end?.split(':')[1]
            let timeLine = day1 + '-' + day2 + ' ' + startTime + '-' + endTime
            let repeatDayOfWeek = item.repeatDayOfWeekString?.split(',') || []
            let timeWeek = ''
            repeatDayOfWeek?.map((v, index) => {
              timeWeek =
                timeWeek +
                this.getWeekName(v) +
                (index != repeatDayOfWeek.length - 1 ? '/' : '')
            })
            time = timeLine + this.$t('（每') + timeWeek + '）'
          } else {
            let day = dayjs(item.meetingStartTime.split(' ')[0]).format(
              'YYYY.MM.DD'
            )
            let start = item.meetingStartTime.split(' ')[1]
            let end = item.meetingEndTime.split(' ')[1]
            let startTime = start?.split(':')[0] + ':' + start?.split(':')[1]
            let endTime = end?.split(':')[0] + ':' + end?.split(':')[1]
            time = day + ' ' + startTime + '-' + endTime
          }
          item.time = time
          item.time = time
          if (item.type == 'MEETING_SERVICE') {
            if (item.state == 'PENDING') {
              item.isMydone = 2
              item.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/toAllocated.png') : require('@/assets/images/toAllocatedE.png')
            } else if (item.state == 'ASSIGN') {
              item.isMydone = 3
              item.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/waitServer.png') : require('@/assets/images/waitServerE.png')
            } else if (item.state == 'GRADE') {
              item.isMydone = 4
              item.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/Review.png') : require('@/assets/images/ReviewE.png')
            } else if (item.state == 'COMPLETED') {
              item.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/CompletedGreen.png') : require('@/assets/images/CompletedGreenE.png')
            } else if (item.state == 'CANCELLED') {
              item.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/Canceled.png') : require('@/assets/images/CanceledE.png')
            }
          } else {
            if (item.state == 'PENDING') {
              item.isMydone = 1
              item.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/Approval.png') : require('@/assets/images/ApprovalE.png')
            } else if (item.state == 'COMPLETED') {
              item.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/CompletedGreen.png') : require('@/assets/images/CompletedGreenE.png')
            } else if (item.state == 'CANCELLED') {
              item.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/Canceled.png') : require('@/assets/images/CanceledE.png')
            } else if (item.state == 'REVOKE') {
              item.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/Revoked.png') : require('@/assets/images/RevokedE.png')
            } else if (item.state == 'EXPIRED') {
              item.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/Expired.png') : equire('@/assets/images/ExpiredE.png')
            } else if (item.state == 'REJECTED') {
              item.imgUrl = this.locale == 'zh-CN' ? require('@/assets/images/Refused.png') : require('@/assets/images/RefusedE.png')
            }
          }
        })
        if (
          !newRes?.results ||
          newRes?.results.length == 0 ||
          newRes?.count <= 10
        ) {
          this.inviteFinished = true
        } else {
          this.inviteFinished = false
        }
        switch (data.tabState) {
          case 'PENDING':
            let list1 = newRes?.results || []
            this.pendingList =
              data.page == 1 ? list1 : [...this.pendingList, ...list1]
            this.allNumber = newRes?.count
              ? newRes?.count <= 99
                ? newRes?.count
                : 99
              : ''
            break
          case 'PROCESSED':
            let list2 = newRes?.results || []
            this.processedList =
              data.page == 1 ? list2 : [...this.processedList, ...list2]
            break
          case 'CREATE':
            let list3 = newRes?.results || []
            this.createdList =
              data.page == 1 ? list3 : [...this.createdList, ...list3]
            break
          case 'EXPIRED':
            let list4 = newRes?.results || []
            this.expireList =
              data.page == 1 ? list4 : [...this.expireList, ...list4]
            break
        }
      } catch (error) {
        console.log(error)
      }
      this.isCancel = false
      this.processedLoading = false //已处理
      this.myLoading = false //待处理
      this.createdLoading = false //我创建
      this.expireLoading = false //已过期
      this.isLoading = false
      this.finished = true
      if (data && data.loading) {
        setTimeout(() => {
          Toast(this.$t('刷新成功'))
          this.isLoading = false
          this.isCancel = false
        }, 500)
      }
      // }
    },
    clickeCancel() { },
    onRefuse(data) {
      this.choseData = data
      this.showRefuse = true
      this.refuseMessage = ''
    },
    onOk(data) {
      this.choseData = data
      this.showOk = true
      this.meetingRoomName = data.meetingRoomName
      this.areaid = data.meetingRoomId
      let index = this.areaList.findIndex((item) => {
        return item.id === data.meetingRoomId
      })
      this.meetingChoseLevel = data.meetingLevel
      this.areaResult = [index]
    },
    onAllocation(data) {
      this.choseData = data
      this.showAllocation = true
      this.servicePeopelName = ''
      this.servicePeopelId = ''
      this.servicePersonnerlDpt = ''
    },
    onDone(data) {
      this.choseData = data
      this.showDone = true
    },
    onComment(data) {
      this.choseData = data
      this.showComment = true
      this.commentValue = 0
    },
    clickOkClose() {
      this.choseData = {}
      this.showOk = false
    },
    clickRefuseClose() {
      this.choseData = {}
      this.showRefuse = false
    },
    clickAllocationClose() {
      this.choseData = {}
      this.showAllocation = false
    },
    clickDoneClose() {
      this.choseData = {}
      this.showDone = false
    },
    clickCommentClose() {
      this.choseData = {}
      this.showComment = false
    },
    cilkcshowServicePeopel() {
      this.showAllocation = false
      this.showServicePeopel = true
    },
    toMeetingInform() {
      if (this.areaResult.length == 0) {
        Toast.fail(this.$t('会议室不能为空'))
        return
      }
      let index = this.areaResult[0]
      this.meetingRoomName = this.areaList[index].name
      this.areaid = this.areaList[index].id
      this.showArea = false
    },
    geth5MeetingServiceRecord() {
      this.choseData = {}
      let data = {
        page: 1,
        pageSize: 10,
        staffId: this.user.id,
        companyId: this.user.companyId,
        isCancel: false,
        loading: true,
        tabState: 'PENDING',
      }
      this.pendingPage = 1
      this.fetchAppointmentList(data)
    },
    async IsDoOk(flag, id) {
      this.showToast = false
      this.isUseDoOk = true
      let remark = {}
      if (
        this.meetingChoseLevel != this.choseData.meetingLevel ||
        this.areaid != this.choseData.meetingRoomId
      ) {
        remark = {
          meetingRoomName: this.meetingRoomName,
          meetingLevel: this.meetingChoseLevel,
        }
      }
      try {
        await processingData({
          approverId: this.user.id,
          companyId: this.user.companyId,
          id: this.choseData.id,
          meetingLevel: this.meetingChoseLevel,
          meetingRoomId: this.areaid,
          state: 'APPROVED',
          remark:
            JSON.stringify(remark) === '{}'
              ? undefined
              : JSON.stringify(remark),
          openMeetingService:
            this.areaid != this.choseData.meetingRoomId
              ? flag
                ? flag
                : false
              : undefined,
          meetingManger: id ? id : undefined,
        })
        this.choseData = {}
        this.geth5MeetingServiceRecord()
        this.showOk = false
        this.isUseDoOk = false
        Toast(this.$t('已同意'))
      } catch (error) {
        Toast.fail(error.response.data)
      } finally {
        this.choseData = {}
        this.showOk = false
        this.isUseDoOk = false
      }
    },
    async doOk() {
      if (
        this.areaid != this.choseData.meetingRoomId &&
        this.choseData.openMeetingService
      ) {
        getMeetingRoomById(this.areaid).then((res) => {
          if (res.openMeetingService && res.meetingManger) {
            this.IsDoOk(res.openMeetingService, res.meetingManger)
          } else {
            this.showToast = true
          }
        })
      } else {
        this.IsDoOk()
      }
    },
    async doRefuse() {
      try {
        this.isUseRefuse = true
        await processingData({
          approverId: this.user.id,
          companyId: this.user.companyId,
          id: this.choseData.id,
          remark: this.refuseMessage,
          state: 'REJECTED',
        })
        this.choseData = {}
        this.geth5MeetingServiceRecord()
        this.showRefuse = false
        this.isUseRefuse = false
        Toast(this.$t('已拒绝'))
      } catch (error) {
        Toast.fail(error.response.data)
      } finally {
        this.choseData = {}
        this.showRefuse = false
        this.isUseRefuse = false
      }
    },
    async doAllocation() {
      if (this.servicePeopelId) {
        try {
          this.isUseAllocation = true
          await assignPersonnel({
            staffId: this.user.id,
            servicePersonnerl: this.servicePeopelId,
            servicePersonnerlDpt: this.servicePersonnerlDpt,
            todoId: this.choseData.id,
          })
          this.choseData = {}
          this.geth5MeetingServiceRecord()
          this.showAllocation = false
          this.isUseAllocation = false
          Toast(this.$t('已完成分配'))
        } catch (error) {
          Toast.fail(error.response.data)
        } finally {
          this.choseData = {}
          this.isUseAllocation = false
          this.showAllocation = false
        }
      } else {
        return
      }
    },
    async doDone() {
      try {
        this.isUseDone = true
        await serviceComplete({
          staffId: this.user.id,
          todoId: this.choseData.id,
        })
        this.choseData = {}
        this.geth5MeetingServiceRecord()
        this.showDone = false
        this.isUseDone = false
        Toast(this.$t('已完成'))
      } catch (error) {
        Toast.fail(error.response.data)
      } finally {
        this.choseData = {}
        this.showDone = false
        this.isUseDone = false
      }
    },
    async doComment() {
      if (this.commentValue < 1) {
        return
      } else {
        try {
          this.isUseComment = true
          await submitterGrade({
            score: this.commentValue,
            todoId: this.choseData.id,
          })
          this.choseData = {}
          this.geth5MeetingServiceRecord()
          this.showComment = false
          this.isUseComment = false
          Toast(this.$t('已完成点评'))
        } catch (error) {
          Toast.fail(error.response.data)
        } finally {
          this.choseData = {}
          this.isUseComment = false
          this.showComment = false
        }
      }
    },
    toInform() {
      this.showServicePeopel = false
      this.showAllocation = true
    },
    confirmSearch(data) {
      let people = data[0]
      let departmentId = people?.departmentId?.split(',')[0]
      this.servicePeopelName = people.name
      this.servicePeopelId = people.id
      this.servicePersonnerlDpt = people.id + '-' + departmentId
      this.showServicePeopel = false
      this.showAllocation = true
    },

    async onRefresh() {
      let data = {
        page: 1,
        pageSize: 10,
        staffId: this.user.id,
        companyId: this.user.companyId,
        isCancel: false,
        loading: true,
      }
      switch (this.active) {
        case 0:
          data.tabState = 'PENDING'
          this.pendingPage = 1
          this.fetchAppointmentList(data)
          break
        case 1:
          data.tabState = 'PROCESSED'
          this.processedPage = 1
          this.fetchAppointmentList(data)
          break
        case 2:
          data.tabState = 'CREATE'
          this.createdPage = 1
          this.fetchAppointmentList(data)
          break
        case 3:
          data.tabState = 'EXPIRED'
          this.expirePage = 1
          this.fetchAppointmentList(data)
          break
      }
    },
    onLoad() {
      let data = {
        // page: 1,
        pageSize: 10,
        staffId: this.user.id,
        companyId: this.user.companyId,
        isCancel: true,
      }
      switch (this.active) {
        case 0:
          data.tabState = 'PENDING'
          this.pendingPage += 1
          data.page = this.pendingPage
          this.fetchAppointmentList(data)
          break
        case 1:
          data.tabState = 'PROCESSED'
          this.processedPage += 1
          data.page = this.processedPage
          this.fetchAppointmentList(data)
          break
        case 2:
          data.tabState = 'CREATE'
          this.createdPage += 1
          data.page = this.createdPage
          this.fetchAppointmentList(data)
          break
        case 3:
          data.tabState = 'EXPIRED'
          this.expirePage += 1
          data.page = this.expirePage
          this.fetchAppointmentList(data)
          break
      }
    },
    goBack() {
      this.$router.push('robot')
    },

    representativeInfo(data) {
      this.$router.push({
        name: 'ApproveInforRead',
        query: {
          appointmentId: data.id,
        },
      })
    },
    async hasUser(user, token) {
      if (!user) {
        if (token) {
          const newUser = await queryStaffToekn({ token })
          if (newUser && newUser.token) {
            localStorage.setItem('user', JSON.stringify(newUser))
            localStorage.setItem(
              'cCode',
              JSON.stringify({ code: newUser.companyCode })
            )
            this.user = newUser
          }
        }
      } else {
        this.user = user
        // this.getAreaId(this.user.companyId)
      }
    },
  },
  mounted() {
    this.height = document.body.scrollHeight - 80
    this.user = JSON.parse(localStorage.getItem('user'))
    let token = this.$route.query.token
    this.hasUser(JSON.parse(localStorage.getItem('user')), token)
    this.onLoad()
    this.getAreaId(this.user.companyId)
    this.getUsers(this.user.companyId)
    if (window.injectData && window.injectData.source == 'NewWorkApp') {
      this.sourceIsH5 = false
    }
  },
}
</script>
<style lang="less" scoped>
.van-tab--active {
  color: #009bff !important;
  font-size: 14px;
}

.van-tabs {
  // background: #ffffff !important;
  font-size: 14px;
}

.bookMeetings {
  position: relative;
  background: #edf0f6;
  height: 100vh;
  display: flex;
  flex-direction: column;
  flex: 1;
}

.content {
  width: 100%;
  padding: 12px 10px 12px;
  background-color: #edf0f6;
}

.card {
  padding-bottom: 14px;
  min-height: 136px;
  widows: '100%';
  background: #fefffe;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  margin-bottom: 12px;
  position: relative;
}

.cardNoMargin {
  padding-bottom: 14px;
  min-height: 136px;
  widows: '100%';
  background: #fefffe;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  position: relative;
}

.operation {
  padding: 0 16px;
  display: flex;
  justify-content: center;
  align-items: center;

  .okButton {
    width: 157px;
    height: 32px;
    border-radius: 18px;
    border: 1px solid #3972ff;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #3972ff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .refuseButton {
    width: 157px;
    height: 32px;
    border-radius: 16px;
    border: 1px solid #f6465d;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #f6465d;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 9px;
  }

  .allocationBotton {
    width: 327px;
    height: 32px;
    border-radius: 18px;
    border: 1px solid #3972ff;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 9px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #3972ff;
  }
}

.meeting {
  color: #009bff;
}

/deep/.date-border {
  color: #009bff;
}

.van-dialog {
  border-radius: 4px !important;
}

.bottom {
  display: flex;
  align-items: center;
  padding: 30px 0;
  justify-content: center;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 22px;

  >div {
    width: 96px;
    height: 1px;
    background: rgba(0, 0, 0, 0.15);
  }

  span {
    padding: 0 17px;
  }
}

.no-uesdMeetingRoom {
  padding: 32px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 24px;
  color: #666666;
  font-size: 14px;

  img {
    width: 96px;
    height: 61px;
    margin-bottom: 8px;
  }
}

/deep/.van-cell::after {
  border: none;
}

/deep/.outsiderStyle {
  width: 296px;

  .outsider-title {
    font-size: 18px;
    line-height: 24px;
  }

  .van-cell::after {
    border: none;
  }

  .van-dialog__header {
    padding: 32px 0px 13px;
  }

  .cancel-box {
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    padding: 0 0 20px 49px;

    .first-cancel {
      margin-bottom: 7px;
    }
  }

  .refuse-box {
    font-size: 14px;
    color: #666666;
    line-height: 24px;
    padding: 10px 0 41px;
    display: flex;
    justify-content: center;
  }

  .van-field__label {
    margin-left: 19px;
    width: 29px;
    line-height: 36px;
    font-size: 14px;
    margin-right: 8px;
  }

  .outsider-input {
    border: 1px solid rgba(0, 0, 0, 0.15);
    height: 36px;
    padding-left: 8px;
    width: 192px;
  }

  input::-webkit-input-placeholder {
    color: #cfcfcf;
  }

  input::-moz-placeholder {
    color: #cfcfcf;
  }

  input:-moz-placeholder {
    color: #cfcfcf;
  }

  input:-ms-input-placeholder {
    color: #cfcfcf;
  }
}

.loading-style {
  width: 100%;
  text-align: center;
  margin-top: 50px;
}

.remark-box {
  width: 224px;
  min-height: 80px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
}

.margin8 {
  margin: 0 auto 8px;
}

.margin-repaet {
  margin: 8px auto 16px;
}

.isCancelMask {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tabStyle {
  display: flex;
  justify-content: center;
  align-items: center;
}

.tabNumText {
  width: 20px;
  height: 20px;
  background: #ff4d4f;
  border-radius: 10px;
  border: 1px solid #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
}

.cardStyle {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 12px 14px 18px;
}

.representativeListName {
  width: 320px;
  -o-text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  line-clamp: 2;
  white-space: normal;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #1e2329;
}

.representativeOther {
  display: flex;
  // justify-content: center;
  align-items: center;
  margin-top: 10px;

  .overepresentativeImg {
    width: 16px;
    height: 16px;
    // opacity: 0.4;
    margin-right: 6px;
  }

  .representativeOtherName {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #474d57;
    width: 288px;
    white-space: nowrap;
    /* 禁止换行 */
    overflow: hidden;
    /* 隐藏溢出内容 */
    text-overflow: ellipsis;
    /* 显示省略号 */
    // margin-top: 2px;
  }
}

.representativeTime {
  display: flex;
  // justify-content: center;
  align-items: flex-start;
  margin-top: 10px;

  .overepresentativeImg {
    width: 16px;
    height: 16px;
    // opacity: 0.4;
    margin-right: 6px;
  }

  .representativeOtherTime {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #474d57;
    width: 288px;
    word-break: break-all;
    /* 任意位置都可以断行 */
    /* 或 */
    word-break: break-word;
    /* 类似 overflow-wrap: break-word */
  }
}

.statusImg {
  position: absolute;
  width: 70px;
  height: 70px;
  right: 12px;
  bottom: 12px;
}

/deep/.van-popup {
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  background-color: #f2f4f7;
}

.popupStyle {
  height: 362px;
  width: 100%;
  padding: 8px 12px 14px;
}

.popupHeader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 56px;
  margin-bottom: 12px;
  position: relative;
}

.popupClose {
  position: absolute;
  left: 12px;
  top: 16px;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #1e2329;
}

.popupTitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #1e2329;
}

.bookBox {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 38px;
}

.bookBoxAllocation {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 154px;
}

.bookBoxOk {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

.popupText {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #474d57;
  padding-left: 11px;
  margin-bottom: 200px;
}

.danger-btn {
  width: 351px;
  height: 46px;
  background: #ff4d4f;
  border-radius: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
}

.blue-btn {
  width: 351px;
  height: 46px;
  background: #3972ff;
  border-radius: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
}

.grey-btn {
  width: 351px;
  height: 46px;
  background: rgba(183, 189, 198, 0.6);
  border-radius: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
}

.popupBlock {
  width: 351px;
  height: 72px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 24px;
  margin-bottom: 12px;
}

.popupOk {
  width: 351px;
  height: 72px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  // justify-content: center;
  align-items: center;
  padding-left: 24px;
  // margin-bottom: 12px;
}

.popupOkOther {
  width: 351px;
  height: 92px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 24px;
  // margin-bottom: 12px;
}

.popupComment {
  width: 351px;
  height: 72px;
  background: #ffffff;
  border-radius: 12px;
  display: flex;
  // justify-content: center;
  align-items: center;
  padding-left: 24px;
  margin-bottom: 146px;
}

.commentStyle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #474d57;
}

.timeListTitle {
  height: 56px;
  line-height: 56px;
  border-bottom: 1px solid #ebebeb;
  padding-left: 20px;
}

.timeList {
  position: relative;
  height: 424px;
  border-bottom: 1px solid #ebebeb;
  padding-left: 16px;
  overflow-y: auto;
  overflow-x: hidden;

  .timeListCard {
    height: 52px;
  }

  .van-checkbox__label {
    width: 330px;
  }

  .timeListRange {
    display: block;
    border-bottom: 1px solid #ebebeb;
    padding-left: 6px;
    font-size: 16px;
    height: 52px;
    width: 375px;
    line-height: 51px;

    .extra {
      padding-left: 24px;
    }
  }
}

.dropdownImg {
  width: 20px;
  height: 20px;
  transform: rotate(270deg);
}

.okTextStyle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #1e2329;
}

.okTextGreyStyle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #b7bdc6;
}
</style>
